import PropTypes from 'prop-types';
import React from 'react';

import { withErrorBoundary } from '../Core/ErrorBoundary';
import ProgressStep from './ProgressStep';

function ProgressBar({ steps, selectedStep, orderId }) {
  const selectedIndex = steps.findIndex((s) => s.step === selectedStep);

  return (
    <div className="BookingNavigation">
      <div className="BookingNavigation_container">
        <ul className="BookingNavigation_list">
          {steps.map(({ uri, text, step }, index) => (
            <ProgressStep
              key={step}
              index={index}
              isSelected={selectedStep === step}
              url={`${uri}${index === 0 ? `&orderId=${orderId}` : `?orderId=${orderId}`}`}
              text={text}
              isComplete={index < selectedIndex}
              isUserJourneyCompleted={selectedIndex === steps.length - 1}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      uri: PropTypes.string,
      text: PropTypes.string,
      step: PropTypes.string,
    })
  ),
  selectedStep: PropTypes.string,
  orderId: PropTypes.string,
};

ProgressBar.defaultProps = {
  steps: [],
  selectedStep: '',
};

export default withErrorBoundary(ProgressBar);
